import { render, staticRenderFns } from "./SwiperCoverflowEffect.vue?vue&type=template&id=0ec8633c"
import script from "./SwiperCoverflowEffect.vue?vue&type=script&lang=js"
export * from "./SwiperCoverflowEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports